@if (dropdownsReady()) {
	<md-drop-down
		label="Lesson Type"
		placeholder="Lesson Type"
		[dense]="true"
		[options]="lessonTypeOptions()"
		[value]="lesson().lessonTypeID"
		[disabled]="dropdownsDisabled()"
		(change)="updateType($event)"
	>
	</md-drop-down>

	@if (showAttendance()) {
		<md-drop-down
			label="Attendance"
			placeholder="Attendance"
			[dense]="true"
			[options]="attendanceStatusOptions()"
			[value]="lesson().attendanceStatusID"
			[disabled]="attendanceDisabled()"
			(change)="updateAttendance($event)"
		>
		</md-drop-down>
	}
} @else {
	<div class="loading-placeholder">Loading options...</div>
}
